import { AfterViewInit, Component, EventEmitter, Injector, Input, Output, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BaseComponent } from 'src/app/common/base/base.component';
import { PendingCatalogColor } from 'src/app/common/enumerations/enumerations';
import { NotificationTemplate } from 'src/app/components/catalogs/notifications/services/notification-template';
import { PendingCatalog, PendingCatalogType } from 'src/app/services/pending-approvals/pending-approval';
import { CatalogService } from '../../catalog-service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'notifications-side',
  templateUrl: './notifications-side.component.html',
  styleUrls: ['./notifications-side.component.scss']
})
export class NotificationsSideComponent extends BaseComponent implements AfterViewInit {

  @Input() filter?: string;
  //@Output() loading = new EventEmitter<boolean>();
  @Output() selectedRow = new EventEmitter<NotificationTemplate>();

  notificationTemplates?: NotificationTemplate[];
  notificationTemplatesFiltered?: NotificationTemplate[];
  notificationTemplates$!: Observable<NotificationTemplate[]>;
  notificationTemplatesSubs!: Subscription;

  public displayedColumns: string[] = ['name'];
  public dataSource!: MatTableDataSource<NotificationTemplate>;

  showInactive!: boolean;
  selectedRowIndex?: number;
  pendingCatalog = PendingCatalogColor;
  private pendingNotification?: PendingCatalog;
  private viewInitialized = false;

  constructor(
    protected override injector: Injector,
    private catalogService: CatalogService,

  ) {
    super(injector);
    this.loadNotificationTemplates();
  }

  override ngOnDestroy(): void {
    this.notificationTemplatesSubs?.unsubscribe();
    super.ngOnDestroy();
  }

  /**
   * Completes the pending-row selection after the parent output binding is available.
   */
  ngAfterViewInit(): void {
    this.viewInitialized = true;
    this.selectPendingNotification();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filter'])
      this.filterNotifications();

  }

  /**
   * Loads notification templates and prepares a pending navigation request for selection.
   */
  loadNotificationTemplates() {
    //this.loading.emit(true);
    this.notificationTemplates$ = this.store.select(state => state.NotificationTemplates.data);
    this.notificationTemplatesSubs = this.notificationTemplates$.subscribe(data => {
      if (data?.length) {
        this.pendingNotification = this.getPendingNotification();
        if (this.pendingNotification) this.showInactive = true;
        this.notificationTemplates = data.sort((a, b) => this.utils.sort(a.name, b.name));
        this.filterNotifications();
        if (this.viewInitialized) this.selectPendingNotification();
        //this.loading.emit(false);
      }
    });
  }

  /**
   * Gets the notification-template navigation request passed from Pending Actions.
   * @returns The pending notification template request, when one exists.
   */
  private getPendingNotification(): PendingCatalog | undefined {
    return this.catalogService.pendingCatalog?.approvalType == PendingCatalogType.NotificationTemplate
      ? this.catalogService.pendingCatalog
      : undefined;
  }

  /**
   * Selects and opens the notification template requested by Pending Actions after the catalog data loads.
   */
  private selectPendingNotification(): void {
    const pendingNotification = this.pendingNotification;
    if (!pendingNotification) return;

    const pendingId = pendingNotification.id || pendingNotification.pendingID * -1;
    const notificationTemplate = this.dataSource.data.find(template => template.id == pendingId);
    if (!notificationTemplate) return;

    this.selectedRowIndex = notificationTemplate.id;
    this.selectedRow.emit(notificationTemplate);
    this.pendingNotification = undefined;
    this.catalogService.pendingCatalog = undefined;
  }

  filterNotifications() {
    this.notificationTemplatesFiltered = this.notificationTemplates?.filter(t => t.name.toLowerCase().includes(this.filter?.toLowerCase() ?? ''))
    if (this.showInactive == true) {
      this.dataSource = new MatTableDataSource(this.notificationTemplatesFiltered);
    } else {
      this.dataSource = new MatTableDataSource(this.notificationTemplatesFiltered?.filter(x => x.status == 1));
    }
  }

  showInactiveNotificationTemplates(e: any) {
    this.showInactive = e.checked;
    this.filterNotifications();
  }

  async highlight(row: NotificationTemplate) {
    if (await this.canDeactivate()) {
      this.selectedRowIndex = row.id;
      this.selectedRow.emit(row);
    }
  }


}
